<script setup>
defineProps({
  title: {
    type: String,
    required: true,
  },
  infoTippyContent: {
    type: String,
    required: false,
  },
})
</script>

<template>
  <div class="flex flex-col justify-between gap-2">
    <div class="flex">
      <p class="font-semibold text-secondary">{{ title }}</p>
      <InfoTippy
        v-if="infoTippyContent"
        :content="infoTippyContent"
        class="shrink-0 ml-2"
      />
    </div>
    <div class="w-full"><slot /></div>
  </div>
</template>
